import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import style from './Faq.module.css';
import { Faq } from '../../pages/runtime-typechecker';
import { Context } from '../../../src/AppContext';
import { setDateAsTomorrow } from '../../utils/timeUtils';
import { ifAdsPresent } from '../../utils/adsUtils';

type FaqProps = {
  type?: string;
  data?: Faq[];
  getListingUrl?: () => string; //valid only for
  pageUrl?: string;
  isMobileDevice: boolean;
  FaqTitle?: string;
};
const FaqSection = ({
  data = [],
  pageUrl,
  type = '',
  getListingUrl,
  isMobileDevice,
  FaqTitle = ''
}: FaqProps) => {
  const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
  useEffect(() => {
    const list = document.getElementsByClassName('faqBookNowButton');
    for (let i = 0; i < list.length; i++) {
      list[i].addEventListener(`click`, e => {
        e.preventDefault();
        trackTemplateEvent(`Bus_SEO${type}_FAQ_Book_Now_Click`);

        let redirectionUrl = isMobileDevice
          ? 'https://www.makemytrip.com/mbus?'
          : `https://www.makemytrip.com/bus-tickets?`;
        if (getListingUrl) redirectionUrl = getListingUrl();
        redirectionUrl = `${setDateAsTomorrow(redirectionUrl)}${omniUrlArgs}`;
        if (ifAdsPresent()) {
          redirectionUrl = redirectionUrl.replace('NoAds', 'Ads');
        }
        window.location = Object(redirectionUrl);
      });
    }
  }, []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
            {
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": ${JSON.stringify(
              data.map(faq => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: `${faq.answer} <a href=${pageUrl}>Book Now</a>`
                }
              }))
            )}
            }
          `}
        </script>
      </Helmet>
      <div
        style={{ display: 'none' }} // disabled in SSR HTML
        className={`${style.faqWrap__top__mob}`}
      >
        <h2 className="font22 latoLight appendBottom5">
          {FaqTitle ? FaqTitle : `Frequently Asked Questions`}
        </h2>
      </div>
      <div className={`${style.faqWrap__top__desk}`}>
        <h2>{FaqTitle ? FaqTitle : `Frequently Asked Questions`}</h2>
      </div>

      <div className={style.faqWarp}>
        {data.map((faq, idx) => {
          return (
            <div key={'faq_' + idx}>
              <div className={style.faqWrap__top__desk}>
                <div className={style.qusAunWrap}>
                  <p className={style.qus}>{'Q: ' + faq.question}</p>
                  <div className={`makeFlex`}>
                    <div className={style.aun}>{`A:`} </div>
                    <div
                      className={style.aun}
                      dangerouslySetInnerHTML={{
                        __html: `${faq.answer.concat(
                          ` <a style="white-space: nowrap;" class="faqBookNowButton">Book Now</a>`
                        )}`
                      }}
                    ></div>
                  </div>
                </div>
              </div>

              <div className={style.faqWrap__top__mob}>
                <div className={style.qusAunWrap}>
                  <p className={style.qus}>{faq.question}</p>
                  <p
                    className={style.aun}
                    dangerouslySetInnerHTML={{
                      __html: `${faq.answer.concat(
                        ` <a style="white-space: nowrap;" class="faqBookNowButton">Book Now</a>`
                      )}`
                    }}
                  ></p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default FaqSection;
